// =============================================================================
// ToastContainer.tsx — Toast notification system
// Project: Texas Hold'em Social Casino
// =============================================================================
// Renders active toast notifications at the top of the screen.

import React from 'react'
import { useUIStore } from '../store/ui-store'

export default function ToastContainer(): React.ReactElement {
  const { toasts, dismissToast } = useUIStore()

  if (toasts.length === 0) return <></>

  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`toast toast-${toast.type}`}
          onClick={() => dismissToast(toast.id)}
        >
          {toast.message}
        </div>
      ))}
    </div>
  )
}
